// app/components/Layout/LanguageSwitcher.tsx
"use client"

import { usePathname } from "next/navigation"
import Image from "next/image"
import { useEffect } from "react"
import esFlag from "/public/images/prflag.png"
import enFlag from "/public/images/usflag.png"
import styles from "./LanguageSwitcher.module.css"
import { getStoredLanguage, setStoredLanguage } from "@/utils/languageDetection"

export default function LanguageSwitcher({
  currentLang,
}: {
  currentLang: string
}) {
  const pathname = usePathname()
  const isEnglish = currentLang === "en"

  const toggleLanguage = () => {
    const newLang = isEnglish ? "es" : "en"
    setStoredLanguage(newLang)
    window.location.href = `${pathname}`
  }

  return (
    <div className={styles.flagToggle} onClick={toggleLanguage}>
      <div
        className={`${styles.flagWrapper} ${isEnglish ? styles.active : ""}`}
      >
        <Image src={enFlag} alt="English" className={styles.flag} />
      </div>
      <div
        className={`${styles.flagWrapper} ${!isEnglish ? styles.active : ""}`}
      >
        <Image src={esFlag} alt="Español" className={styles.flag} />
      </div>
    </div>
  )
}
